import { useStorage } from '@vueuse/core';
import type {
    LoginPayload, LoginResponse,
} from '@/types/auth'
import type {
    UserData
} from '@/types/users'
import { useApiUser } from "@/composables/useApiUser";
import { useApi } from "@/composables/useApi";
import { useApiConfig } from "@/composables/useApiConfig";

export const useApiAuth = () => {
    const { auth: authConfiguration } = useApiConfig();
    const token = useStorage<string | null>(authConfiguration.tokenKey, null);
    const user = useApiUser();

    async function refresh() {
        const { data, fetch } = useApi<UserData>({
            url: authConfiguration.endpoints.user,
            method: 'GET',
            query: {
                includes: ['primary_location', 'channels']
            }
        });

        await fetch();

        if(data.value === null) {
            token.value = null;
            return;
        }
        user.value = data.value;
    }

    async function login(credentials: LoginPayload) {
        const { data, error, fetch } = useApi<LoginResponse, LoginPayload>({
            url: authConfiguration.endpoints.login,
            method: 'POST'
        });

        await fetch(credentials);

        if(data.value?.token) {
            token.value = data.value.token;
            reloadNuxtApp();

            // await refresh();

            navigateTo(authConfiguration.redirects.userIndexPage);
            return;
        }

        throw new Error(error.value?.message ?? 'Please contact your administrator.');
    }

    async function logout() {
        const { fetch } = useApi<{message: string}>({
            url: authConfiguration.endpoints.logout,
            method: 'POST'
        });

        await fetch();

        token.value = null;
        user.value = null;
        
        navigateTo(authConfiguration.redirects.loginPage);
    }

    return {
        login,
        logout,
        token,
        user,
        refresh
    }
}